import { Drawer, Grid, Typography, Button } from "@mui/material";
import { WSIcons } from "../../commonFunctions/iIcons";
import { WSTabs } from "../../Components/Tabs/WSTabs";
import { FormProvider, useForm } from "react-hook-form";
import { CashDiscountReceipt } from "./CashDiscountReceipt";
import { CashDiscountItem } from "./CashDiscountItem";

interface ChooseDiscountProps {
  open: boolean;
  onClose: () => void;
}

export const ChooseDiscount: React.FC<ChooseDiscountProps> = ({ open, onClose }) => {
    const methods = useForm();
    const { handleSubmit, control, register } = methods;
  const tabs = [
    { label: "Discount on Receipt", content: "" },
    { label: "Cash Discount on Receipt", content: <CashDiscountReceipt/> },
    { label: "Discount on Item", content: "" },
    { label: "Cash Discount On Item", content: <CashDiscountItem/> },
  ];
  const onSubmit = async (data: any) => {
    debugger;
    console.log("onsubmit===>", data); // You can perform any action with the submitted data here
  };
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {   backdropFilter: 'none', width: '60rem', padding: '1rem',}}}
        
    >
    
    <Grid container direction="column" spacing={2}>
        {/* Header with Close Button */}
        <Grid item container justifyContent="space-between" alignItems="center">
          <Typography variant="h6" fontWeight="bold" color={"green"}>
            Choose Discount
          </Typography>
          <WSIcons.CloseIcon
            onClick={onClose}
            sx={{ backgroundColor: "red" }}
          />
        </Grid>

        {/* Tabs Section */}
        <Grid item>
          <Grid
            sx={{
              border: '1px solid #ccc', 
            height:"35rem",
              p: 2,                     
            }}
          >
            <WSTabs id={"tabs"} control={control} name={"tabs"} tabs={tabs} />
          </Grid>
        </Grid>

        {/* Buttons Section */}
        <Grid item container justifyContent="flex-end" spacing={2} >
          <Grid item>
            <Button variant="outlined" onClick={onClose} sx={{borderColor:"green",color:"black"}}>
              Remove
            </Button>
          </Grid>
          <Grid item>
            <Button variant="contained" color="success" onClick={handleSubmit(onSubmit)}>
              Apply
            </Button>
          </Grid>
        </Grid>
      </Grid>
   
    </Drawer>
  );
};
